// extracted by mini-css-extract-plugin
export default {"expiredContainer":"expiredContainer__1YZdy","title":"title__383yf"};
    if(module.hot) {
      // 1790586298045
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  